module.exports = __webpack_public_path__ + "static/media/Default.0781d6f2.jpeg";